<form [formGroup]="merchantOverviewForm" class="merchant-overview-form">
  <div class="merchant-overview-form-fields">
    <div class="merchant-overview-form-row">
      <div class="input full-height-width">
        <label for="merchant-overview-name">Name</label>
        <input
          id="merchant-overview-name"
          type="text"
          pInputText
          formControlName="Name"
          data-cy="merchant-overview-name"
        />
      </div>
    </div>

    <div class="merchant-overview-form-row">
      <ep-price-control
        class="full-width"
        formControlName="BasePrice"
        label="Base Monthly Price"
        data-cy="merchant-overview-base-price"
      ></ep-price-control>
      <app-merchant-sms-price-control
        class="full-width"
        formControlName="PerSmsprice"
        label="Price Per SMS"
        data-cy="merchant-overview-sms-price"
      ></app-merchant-sms-price-control>
    </div>

    <div class="merchant-overview-form-row">
      <div class="input full-height-width">
        <label for="merchant-overview-sales-representative">Primary Representative</label>
        <p-dropdown
          id="merchant-overview-sales-representative"
          [options]="representativeOptions"
          optionLabel="name"
          optionValue="RepresentativeId"
          [showClear]="true"
          placeholder="Select a representative"
          formControlName="SalesRepresentativeId"
          data-cy="merchant-overview-sales-representative"
        ></p-dropdown>
      </div>
    </div>

    <div class="merchant-overview-form-row" data-cy="merchant-overview-phone-number">
      <div class="input full-height-width">
        <label>Phone Number Attached</label>
        <p>{{ merchant?.HasPhoneNumberAttached ? 'Yes' : 'No' }}</p>
      </div>
    </div>
  </div>
</form>
